import Card from 'components/atoms/Card/Card';
import Heading from 'components/atoms/Heading/Heading';
import Txt from 'components/atoms/Txt/Txt';
import { useRouter } from 'next/router';
import Graphic from './assets/graphic.svg';
import classes from './ReferralsBanner.module.scss';

export type Props = {};

export default function ReferralsBanner({}: Props) {
  const router = useRouter();

  return (
    <Card className={classes.root}>
      <div className={classes.container} onClick={() => router.push('/referrals')}>
        <div className={classes.leftColumn}>
          <Heading level={2} className={classes.header}>
            Refer A Friend
          </Heading>
          <Txt component="p" className={classes.description}>
            Spread the Mobiworkx love and earn cash rewards for successful referrals.
          </Txt>
        </div>
        <Graphic className={classes.graphic} width={73} height={60} />
      </div>
    </Card>
  );
}
